import { queryOptions } from '@tanstack/react-query';

import { optimiserService } from '~api/services';

export const optimiserQueryOptions = queryOptions({
  queryKey: ['optimisations', 'list'],
  queryFn: () => optimiserService.getPatternDesignOptimisations(),
});

export const optimiserByBlastQueryOptions = (blastName: string) =>
  queryOptions({
    queryKey: ['optimisations', 'blast', blastName],
    queryFn: () => optimiserService.getPatternDesignOptimisationsByBlast(blastName),
  });
